import { useAuthenticationStore } from "@/stores/authentication";
import FetchService from "./fetch.service";
import authHeader from "./auth-header";
const BASE_URL = import.meta.env.VITE_BASE_URL;

const API_URL = BASE_URL + "/api/auth/";
// const API_URL = 'http://127.0.0.1:8000/api/auth/';
class AuthService {
  parseJwt(token, url = true) {
    const base64 = url ? token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/") : token;
    // `token` is often base64url without `=` padding (common for JWTs).
    // Some browsers are strict about missing padding when calling `atob()`.
    const padLength = (4 - (base64.length % 4)) % 4;
    const padded = base64 + "=".repeat(padLength);
    const jsonPayload = decodeURIComponent(
      atob(padded)
        .toString()
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  isCorrectSchool(schoolId) {
    const token = useAuthenticationStore().getToken();
    if (token?.access_token) {
      const jwt = this.parseJwt(token.access_token);
      if (schoolId == jwt.school_id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isLoggedIn() {
    const token = useAuthenticationStore().getToken();
    if (token?.access_token) {
      const jwt = this.parseJwt(token.access_token);
      const expirationDate = new Date(jwt.exp * 1000);
      const currentDate = new Date();
      if (currentDate < expirationDate) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  loginFromHash(hashString) {
    let token;
    try {
      token = JSON.parse(atob(hashString));
    } catch {
      console.log("count not decode the hash");
      return false;
    }
    if (token.access_token) {
      return token;
    } else {
      return false;
    }
  }

  async login(user, level) {
    const response = await fetch(API_URL + "login", {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({
        authentication_type: level,
        account: user.account,
        district_id: user.district_id,
        username: user.username,
        password: user.password
      })
    });
    // a non-200 response code
    if (!response.ok) {
      return false;
    } else {
      const res = await response.json();
      return res;
    }
  }
  async passwordReminder(user) {
    const response = await fetch(API_URL + "remind", {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(user)
    });
    // a non-200 response code
    if (response.status === 200 || response.status === 201) {
      const data = await response.json();
      return { success: true, data ,status: response.status};
    } else if (response.status === 204) {
      return { success: false, data: "The user account does not exist", status: response.status };
    } else {
      // Retrieve error message if provided in response, or use a default message
      const errorData = await response.json();
      return {
        success: false,
        status: response.status,
        message: errorData.message || "An error occurred while sending the password reminder."
      };
    }
  }
  async resetPassword(user) {
    // Determine headers based on login status
    const headerValues = this.isLoggedIn() ? authHeader(user) : {
      "Content-Type": "application/json"
    };
    const response = await fetch(API_URL + "reset", {
      method: "POST",
      headers: headerValues,
      body: JSON.stringify(user)
    });
    
    // a non-200 response code
    return response.json();
  }

  async register(user) {
    const response = await fetch(API_URL + "register", {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(user)
    });
    // a non-200 response code
    return response.json();
  }
  async refresh() {
    const res = await FetchService.fetchData("*/auth/refresh", "post");
    await useAuthenticationStore().setJWT(res);
  }
}
export const authService = new AuthService();
export default authService;
// 3297567@1045.parent
